module.exports = __webpack_public_path__ + "static/media/our-vision.4acac1b4.jpg";